import styled from "styled-components";

export const Style = styled.div`
  .actions {
    padding: 20px 0px;
    display: grid;
    grid-template-columns: 1fr 1fr;

    .btn-cont {
      display: flex;
      justify-content: flex-end;
    }
  } 

  .main-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-top: 1px solid #eaecf0;
  }
`;
